<script>
  import 'chartjs-adapter-luxon'
  import { Chart } from 'chart.js'
  import annotationPlugin from 'chartjs-plugin-annotation'
  import OccupancyGraphTooltip from '@/components/base/OccupancyGraphTooltip'

  const graphOptions = {
    animation: { duration: 0 },
    responsiveAnimationDuration: 0,
    hover: { animationDuration: 0 },
    scaleBeginAtZero: true,
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      display: false,
    },
    scales: {
      xAxes: [
        {
          type: 'time',
          distribution: 'linear',
          time: {
            unit: 'minute',
          },
          ticks: {
            major: {
              enabled: true,
            },
            source: 'data',
            autoSkipPadding: 25,
            autoSkip: true,
            fontFamily: 'Degular',
            maxRotation: 0,
            minRotation: 0,
          },
        },
      ],
      yAxes: [
        {
          display: true,
          position: 'left',
        },
      ],
    },
  }

  export default {
    name: 'OccupancyGraph',
    props: {
      timezone: String,
      height: {
        type: String,
      },
      tooltipPoints: {
        type: Array,
        default: null,
      },
      max: Number,
      chartModel: {
        type: Object,
      },
      activityZones: {
        type: Array,
      },
      renderKey: Number,
    },
    computed: {
      chartOptions () {
        return graphOptions
      },
      tooltips () {
        return {
          mode: 'index',
          intersect: false,
          enabled: false,
          custom: OccupancyGraphTooltip(this.$refs.occCanvas, this.timezone, this.activityZones),
        }
      },
      yAxes () {
        const stepSize = Math.max(this.max, 1)
        return {
          display: true,
          position: 'left',
          ticks: {
            min: 0,
            stepSize,
            max: this.max,
            fontFamily: 'Degular',
            callback: function (label, _, __) {
              if (label === 0) return 'Vacant'
              if (label <= stepSize) return 'Elevated'
            },
          },
        }
      },
      mergedOptions () {
        return {
          ...this.chartOptions,
          tooltips: this.tooltips,
          scales: {
            ...this.chartOptions.scales,
            yAxes: [this.yAxes],
          },
        }
      },
      plugins () {
        return [annotationPlugin]
      },
    },
    watch: {
      renderKey () {
        this.renderChart(this.chartModel, this.mergedOptions)
      },
    },
    created () {
      this.chartOptions.scales.xAxes[0].adapters = { date: { zone: this.timezone } }
    },
    destroyed () {
      if (window.occChart) window.occChart.destroy()
    },
    methods: {
      renderChart (data, options) {
        if (window.occChart && window.occChart !== null) window.occChart.destroy()
        window.occChart = new Chart(this.$refs.occCanvas.getContext('2d'), {
          type: 'line',
          data,
          options,
        })
      },
    },
    render: function (createElement) {
      return createElement(
        'div', { style: { position: 'relative', height: this.height, width: '100%' } },
        [
          createElement(
            'canvas', {
              attrs: {
                id: 2,
              },
              ref: 'occCanvas',
            },
          ),
        ],
      )
    },
  }
</script>

<style>
.occupancy-chartjs-custom-tooltip {
    background-color: #F1EDE6;
    border-radius: 5px;
    padding: 10px;
    width: 161px;
}
.occupancy-chartjs-custom-tooltip-header {
    font-family: 'Lato';
    font-size: 13px;
    font-style: normal;
    font-weight: 700;
    line-height: 16px;
    letter-spacing: 0.5px;
    text-align: left;
}
.occupancy-chartjs-custom-tooltip__activity-zone {
    font-family: 'Lato';
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: 12px;
    letter-spacing: 0.5px;
    text-align: left;
    margin-top: 10px;
}
.occupancy-chartjs-custom-tooltip__occupancy {
    font-family: 'Lato';
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: 0.5px;
    text-align: left;
}
</style>
